const API = process.env.REACT_APP_BACKEND_URL + '/api';

// Opens Paystack checkout in a popup and polls until paid, so the SPA (and the
// uploaded PDF) stays alive. Resolves 'paid' | 'failed' | 'timeout'.
export const startPaystackCheckout = async (planId, { onPaid } = {}) => {
  const popup = window.open('about:blank', 'paystack_checkout', 'width=520,height=740');

  let data;
  try {
    const res = await fetch(`${API}/payments/create-checkout`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ plan_id: planId, origin_url: window.location.origin }),
    });
    data = await res.json();
    if (!res.ok || !data.url) {
      throw new Error(data.detail || 'Failed to start checkout');
    }
  } catch (e) {
    try { popup?.close(); } catch {}
    throw e;
  }

  if (popup && !popup.closed) {
    popup.location = data.url;
  } else {
    window.open(data.url, '_blank');
  }

  return new Promise((resolve) => {
    const started = Date.now();
    const iv = setInterval(async () => {
      if (Date.now() - started > 10 * 60 * 1000) {
        clearInterval(iv);
        resolve('timeout');
        return;
      }
      try {
        const r = await fetch(`${API}/payments/status/${data.session_id}`, { credentials: 'include' });
        const s = await r.json();
        if (s.payment_status === 'paid') {
          clearInterval(iv);
          try { if (popup && !popup.closed) popup.close(); } catch {}
          if (onPaid) await onPaid();
          resolve('paid');
        } else if (s.payment_status === 'failed' || s.payment_status === 'expired') {
          clearInterval(iv);
          resolve('failed');
        }
      } catch {}
    }, 3000);
  });
};
